import React from "react";

const ResultAnswer = ({ children }) => {
  return (
    <div className="p-[60px] flex items-center justify-center flex-col">
      {children}
    </div>
  );
};

export default ResultAnswer;
